import { render, staticRenderFns } from "./cardDetails.vue?vue&type=template&id=78a2fa6a&scoped=true"
import script from "./cardDetails.vue?vue&type=script&lang=js"
export * from "./cardDetails.vue?vue&type=script&lang=js"
import style0 from "./cardDetails.vue?vue&type=style&index=0&id=78a2fa6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2fa6a",
  null
  
)

export default component.exports